export class NetworkValidationError extends Error {
  constructor(message: string, options?: { cause?: Error }) {
    super(message);
    this.name = 'NetworkValidationError';

    Object.setPrototypeOf(this, NetworkValidationError.prototype);

    if (options?.cause) {
      this.cause = options.cause;
    }
  }
}
